import { affinityToStem } from '@ourbranch/policy-utils';

/**
 * Resolves a policy's current affinity stem from its most recent segment that carries one
 * (falling back to a top-level `global.affinity`). This mirrors the backend gate in
 * staff-appsync-be/lambdas/staff-billing-details/helpers.ts (`getPolicyAffinity` + `affinityToStem`) —
 * the FE gate is UX-only; the lambda independently re-validates. Keep the two in sync. (#33155)
 */
export const resolvePolicyStem = (policyInfo, policy) => {
  const segments = policyInfo?.segments || policy?.segments || [];
  for (let i = segments.length - 1; i >= 0; i--) {
    const affinity = segments[i]?.global?.affinity;
    if (affinity) {
      return affinityToStem(affinity).toUpperCase();
    }
  }
  const topAffinity = policy?.global?.affinity;
  return topAffinity ? affinityToStem(topAffinity).toUpperCase() : null;
};
